import CustomRedirect from '@/components/CustomRedirect';
import { useCurrentUserId } from '@/features/user/currentUser.service';
import routes from '@/routes/routes';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';

const UserShowcaseClientOnly = dynamic(
  () => import('@/pages/user/showcase/index').then((m) => m.UserShowcase),
  {
    ssr: false,
  },
);

export default function UserShowcasePage({ query }: { query: Record<string, string> }) {
  return <UserShowcaseClientOnly query={query} />;
}

export const UserShowcase = ({ query }: { query: Record<string, string> }) => {
  const currentUserId = useCurrentUserId();

  if (!currentUserId) return <CustomRedirect to={routes.error404} />;

  const searchParams = new URLSearchParams(query as Record<string, string>);
  const searchString = searchParams.toString();
  const newUrl = `/user/${currentUserId}/showcase${searchString ? '?' + searchString : ''}`;

  return <CustomRedirect to={newUrl} />;
};

export const getServerSideProps = (context: GetServerSidePropsContext) => {
  return {
    props: {
      query: context.query,
    },
  };
};
